import { FC, useCallback, useState } from "react";
import { Control, useController } from "react-hook-form";
import { Select } from "theme";

import { FormControl, InputLabel, MenuItem, SelectProps, useTheme } from "@mui/material";


export type ControlledSelectProps = Omit<SelectProps, "value" | "onChange"> & {
  control: Control<any>;
  options: {
    label: string;
    value: string | number;
  }[];
  onOptionsChange?: () => void;
}

const ControlledSelect: FC<ControlledSelectProps> = ({
                                                       control,
                                                       name,
                                                       options,
                                                       onOptionsChange,
                                                       ...props
                                                     }) => {
  const { palette } = useTheme();
  const { field } = useController({
    control,
    name: name || "",
  });
  const [value, setValue] = useState<string>(field.value);

  const onSingleChange = useCallback(
    (newValue: string) => {
      setValue(newValue);
      field.onChange(newValue);
      onOptionsChange?.();
    },
    [field, onOptionsChange],
  );

  return (
    <FormControl fullWidth>
    <InputLabel id={name} style={{
      color: palette.text.primary
    }}>{props.label}</InputLabel>
    <Select
      fullWidth
      MenuProps={{
        sx: {
          "& .MuiPaper-root": {
            background: palette.primary.main,
          },
        },
      }}
      value={value || ""}
      labelId={name}
      onChange={(e) => onSingleChange(e.target.value as string)}
      {...props}
    >
      {options.map((el) => {
        return (
          <MenuItem key={el.value} value={el.value}>
            {el.label}
          </MenuItem>
        );
      })}
    </Select>
    </FormControl>
  );
};

export default ControlledSelect;
